import React from "react";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import PersonTable from "../../components/tables/PersonTable";

const MainPersonPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Box
        sx={{
          mb: 4,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{
            position: "absolute",
            left: 16,
          }}
          startIcon={<AddIcon />}
          onClick={() => navigate("create")}
        >
          Create Person
        </Button>
        <Typography variant="h1">Persons</Typography>
      </Box>
      <PersonTable />
    </Box>
  );
};

export default MainPersonPage;
